import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Box
} from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FilterContext } from 'context/FilterContext';
import { TextFieldElement } from 'components/muiInputWrappers';

export type FormFields = {
  ticketId?: number;
  External: boolean;
  externalEventId: number;
  externalOrigin: string;
};

interface Props {
  form: UseFormReturn<FormFields>;
}

function AlteredSearchTickets({ form }: Props) {
  const { t } = useTranslation('global');

  const { storedFilter } = useContext(FilterContext);

  const [isAlertedChecked, setAlertedChecked] = useState<boolean>(
    storedFilter?.requirementfind?.External || false
  );
  const handleAlertedChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      form.setValue('External', event.target.checked ? true : null);
      setAlertedChecked(event.target.checked);
    },
    [form]
  );

  useEffect(() => {
    if (form.getValues('External') === false) {
      form.setValue('External', false);
      setAlertedChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.getValues('External')]);

  useEffect(() => {
    if (storedFilter?.requirementfind) {
      form.setValue(
        'externalOrigin',
        storedFilter?.requirementfind?.externalOrigin
      );
      form.setValue(
        'externalEventId',
        storedFilter?.requirementfind?.externalEventId
      );
    }
  }, []);

  return (
    <Box>
      <Grid data-testid="alerted-checkbox">
        <FormControlLabel
          checked={isAlertedChecked}
          control={<Checkbox name="External" onChange={handleAlertedChange} />}
          label={t('common.commonProperties.alerted')}
          name="External"
        />
      </Grid>
      <br />
      <Typography>{t('common.commonProperties.externalOrigin')}</Typography>
      <TextFieldElement
        control={form?.control}
        name="externalOrigin"
        placeholder={t('common.commonProperties.externalOrigin')}
        size="small"
        style={{ width: '100%' }}
        type="text"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 50,
            message: t('ticket.messages.valueLongerThan50')
          }
        }}
        variant="outlined"
      />
      <br />
      <br />
      <Typography>{t('common.commonProperties.externalEventId')}</Typography>
      <TextFieldElement
        control={form?.control}
        name="externalEventId"
        placeholder={t('common.commonProperties.externalEventId')}
        size="small"
        style={{ width: '100%' }}
        type="number"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default AlteredSearchTickets;
